import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";

export function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const role = sessionStorage.getItem("ys_signup_role") || "buyer";
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role });
        setUser(data.user);
        window.history.replaceState(null, "", "/browse");
        navigate("/browse", { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error("Google sign-in failed:", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-ys-canvas gap-4">
      <img src={LOGO_URL} alt="Yard-skip" className="w-16 h-16 rounded-xl animate-pulse" />
      <div className="ys-spinner" />
      <p className="text-slate-500 text-sm">Signing you in…</p>
    </div>
  );
}
